import { Injectable } from '@angular/core';

import { Geoid } from '../geoid';
import { Adapter } from './adapter';

@Injectable({
    providedIn: 'root',
})
/**
 * Adapts the result of the EPSG search
 */
export class GeoidAdapterService implements Adapter<Geoid[]> {
    adapt(geoidList: Geoid[]): Geoid[] {
        let minLat = 99;
        let maxLat = -99;
        let minLon = 99;
        let maxLon = -99;

        for (const geoid of geoidList) {
            for (const file of geoid.files) {
                file.region = [
                    parseFloat(file.area.lat_min),
                    parseFloat(file.area.lat_range),
                    parseFloat(file.area.lon_min),
                    parseFloat(file.area.lon_range),
                ];

                if (file.region[0] < minLat) {
                    minLat = file.region[0];
                }
                if (file.region[2] < minLon) {
                    minLon = file.region[2];
                }
                if (file.region[0] + file.region[1] > maxLat) {
                    maxLat = file.region[0] + file.region[1];
                }
                if (file.region[2] + file.region[3] > maxLon) {
                    maxLon = file.region[2] + file.region[3];
                }
            }

            geoid.region.area = [minLat, maxLat - minLat, minLon, maxLon - minLon];
        }

        return geoidList;
    }
}
